import { Dispatch } from 'redux';
import EVENT_TYPES, { getEventProps } from './types';
import API_ROUTES from 'services/apiRoutes';
import { oathApi } from 'services/oathApi';

export const getEvent =
  ({ urlPartner }: getEventProps) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(EVENT_TYPES.eventStart());

    const query_str = urlPartner ? `/${urlPartner}` : '';

    try {
      const response = await oathApi.get(API_ROUTES.GET_EVENT(query_str));
      dispatch(EVENT_TYPES.eventSuccess(response.data));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(EVENT_TYPES.eventError(error.message));
      return Promise.reject(error);
    }
  };
